import { Handler } from "../common/types";
import { IframeActions } from "../common/events";
import { WIDGET_METADATA } from "../common/config";
import { logger } from "../services/logger";

export const clearBetSlip: Handler = (_, { iframe }) => {
  logger.log(`[From MsgBus]: Clear betslip`);
  const widgetType = iframe.getWidgetType();
  const metadata = WIDGET_METADATA[widgetType];

  if (metadata.requiresGtpMapping) {
    iframe.publish(IframeActions.UPDATE_BETSLIP, { byoSelectionDetails: [] });
    logger.log(`[To Iframe]: ${IframeActions.UPDATE_BETSLIP}: []`);
  } else {
    iframe.publish(IframeActions.UPDATE_BETSLIP_ACCA, { selections: [] });
    logger.log(`[To Iframe]: ${IframeActions.UPDATE_BETSLIP_ACCA}: []`);
  }
};
